<template>
  <div
    :class="[cardClass, { selectable: selectable, isMulti: isMultiCities }]"
    class="booking-card-outline"
  >
    <div class="booking-card card-base">
      <div class="row">
        <div class="col-xs-8">
          <slot name="radio-btn">
            Booking Ref.
            <b
              :title="title"
              class="blue-font"
              :class="{ 'other-info': title }"
              :id="booking.recordlocator"
              >{{ booking.recordlocator }}</b
            >
            <span class="blue-font" v-if="booking.parentPnr"
              >({{ booking.parentPnr }})</span
            >
          </slot>
        </div>
        <div
          :class="{
            [flightStatusMap[booking.flightStatus].toLowerCase()]: !selectable,
          }"
          class="col-xs-4 text-right"
        >
          <span v-if="selectable">{{
            type === tripType.roundTrip ? "RoundTrip" : "Oneway"
          }}</span>
          <span v-else>{{ flightStatusMap[booking.flightStatus] }}</span>
        </div>
      </div>
      <div class="row card-content">
        <div :class="splitClass">
          <div class="station-info text-center">
            <div>
              <b>{{ jnys[0].departureDate | toDateString("YYYY MMM D") }}</b>
            </div>
            <div class="emphasize">{{ jnys[0].origin }}</div>
            <div>
              <b>{{ jnys[0].departureDate | toDateString("HH:mm") }}</b>
            </div>
            <div class="flight">{{ jnys[0].flightNo }}</div>
          </div>
        </div>
        <div :class="splitClass" class="text-center">
          <img
            class="margin-top-x2"
            :src="
              type === tripType.roundTrip
                ? images.roundTripFlight
                : images.oneWayFlight
            "
          />
          <div>{{ type === tripType.roundTrip ? "RoundTrip" : "Oneway" }}</div>
          <div class="red-notice">({{ segmentStatus }})</div>
        </div>
        <div :class="splitClass">
          <div class="station-info text-center">
            <div>
              <b>{{
                (type === tripType.roundTrip
                  ? jnys[1].departureDate
                  : jnys[0].arrivalDate) | toDateString("YYYY MMM D")
              }}</b>
            </div>
            <div class="emphasize">{{ jnys[0].destination }}</div>
            <div>
              <b>{{
                (type === tripType.roundTrip
                  ? jnys[1].departureDate
                  : jnys[0].arrivalDate) | toDateString("HH:mm")
              }}</b>
            </div>
            <div class="flight">
              {{
                type === tripType.roundTrip
                  ? jnys[1].flightNo
                  : jnys[0].flightNo
              }}
            </div>
          </div>
        </div>
        <template v-if="type === tripType.multiCity">
          <div :class="splitClass">
            <div class="station-info text-center">
              <div>
                <b>{{ jnys[1].departureDate | toDateString("YYYY MMM D") }}</b>
              </div>
              <div class="emphasize">{{ jnys[1].origin }}</div>
              <div>
                <b>{{ jnys[1].departureDate | toDateString("HH:mm") }}</b>
              </div>
              <div class="flight">{{ jnys[1].flightNo }}</div>
            </div>
          </div>
          <div :class="splitClass" class="text-center">
            <img
              class="margin-top-x2"
              :src="
                type === tripType.roundTrip
                  ? images.roundTripFlight
                  : images.oneWayFlight
              "
            />
            <div>Oneway</div>
            <div class="red-notice">({{ segmentStatus }})</div>
          </div>
          <div :class="splitClass">
            <div class="station-info text-center">
              <div>
                <b>{{ jnys[1].arrivalDate | toDateString("YYYY MMM D") }}</b>
              </div>
              <div class="emphasize">{{ jnys[1].destination }}</div>
              <div>
                <b>{{ jnys[1].arrivalDate | toDateString("HH:mm") }}</b>
              </div>
              <div class="flight">{{ jnys[1].flightNo }}</div>
            </div>
          </div>
        </template>
      </div>
      <div class="row">
        <div class="col-xs-8">
          Booking Date
          <span class="blue-font">{{
            booking.bookingDate | toDateString("YYYY MMM D")
          }}</span>
        </div>
        <div v-if="!selectable" class="col-xs-4 text-right">
          <a
            v-if="editable"
            class="margin-right"
            href="javascript:void(0)"
            @click="openMMB"
          >
            <img :src="images.edit" />
          </a>
          <a class="margin-right" href="javascript:void(0)" @click="printItin">
            <img :src="images.printer" />
          </a>
          <a
            class="margin-right"
            href="javascript:void(0)"
            @click="showItinerary"
          >
            <img :src="images.takeLook" />
          </a>
        </div>
      </div>
      <div class="red-notice">First passenger: {{ firstPaxName }}</div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import config from "../../core/config";
import images from "../../core/images";
import { toQuery } from "../../core/tools";
import { getName } from "../../core/staff-helper";
import {
  tripType,
  flightStatusMap,
  segmentStatus,
  segmentStatusMap,
} from "../../core/enum";
export default {
  inheritAttrs: false,
  name: "booking-card",
  props: {
    selectable: {
      type: Boolean,
      default: false,
    },
    booking: {
      default: () => {},
    },
  },
  computed: {
    images: () => images,
    tripType: () => tripType,
    flightStatusMap: () => flightStatusMap,
    segmentStatus() {
      return this.booking.segmentStatus === segmentStatus.standby
        ? "Standby"
        : "Confirmed";
    },
    firstPaxName() {
      if (this.booking.passengers && this.booking.passengers.length > 0) {
        return getName(this.booking.passengers[0]);
      }
      return "";
    },
    type() {
      let jnys = this.jnys;
      let type = tripType.oneWay;
      if (jnys.length === 2) {
        type =
          jnys[0].origin === jnys[1].destination &&
          jnys[0].destination === jnys[1].origin
            ? tripType.roundTrip
            : tripType.multiCity;
      }
      return type;
    },
    cardClass() {
      let _class = "";
      if (this.selectable) {
        _class = this.type === tripType.multiCity ? "isMultiple" : "";
      } else {
        _class =
          this.type === tripType.multiCity
            ? "col-md-8 col-sm-12 col-xs-12 isMultiple"
            : "col-xl-3 col-lg-4 col-md-6 col-xs-12";
      }
      return _class;
    },
    isMultiCities() {
      return this.type === tripType.multiCity;
    },
    editable() {
      return this.booking.maxStd > new Date().getTime();
    },
    splitClass() {
      return this.type === tripType.multiCity ? "col-xs-2" : "col-xs-4";
    },
    title() {
      if (this.booking.children?.length ?? 0 > 0) {
        return `Sub recordlocators : \r\n${this.booking.children.join("\r\n")}`;
      }
      return "";
    },
    jnys() {
      return this.booking?.journeys ?? [];
    },
    ...mapState({
      token: (s) => s.token,
    }),
  },
  methods: {
    openMMB() {
      let queryObj = {
        lang: "en",
        token: this.token,
        subPnrs: this.booking.children,
        parentPnr: this.booking.parentPnr,
        recordlocator: this.booking.recordlocator,
        type: segmentStatusMap[this.booking.segmentStatus],
      };
      console.log(queryObj);
      let url = `${config.MMB_URL}?${toQuery(queryObj)}`;
      window.open(url, "_blank");
      console.log(url);
    },
    printItin() {
      let url = `${config.B2B_API_URL}/v1/Booking/staff/pdf/${this.booking.recordlocator}?token=${this.token}`;
      window.open(url, "_blank");
    },
    showItinerary() {
      let url = `${config.B2B_API_URL}/v1/Booking/staff/itinerary/${this.booking.recordlocator}?token=${this.token}`;
      window.open(url, "_blank");
    },
  },
  filters: {
    // type
    // 0 = start
    // 1 = end
    getCurrentFlight(flights, type) {
      let result = "";
      if (flights && flights.length > 0) {
        if (type === 0) {
          result = flights[0];
        } else if (type === 1) {
          if (flights[1]) {
            result = flights[1];
          } else {
            result = flights[0];
          }
        }
      }
      return result;
    },
  },
};
</script>
